import React from 'react';
import {translate} from 'react-admin';
import Swal from "sweetalert2";

const Popconfirm = translate(({translate, title = '', description = '', onConfirm = () => {}, children, icon = 'warning' }) => {

    const handleClick = async (event) => {
        event.stopPropagation()
        const result = await Swal.fire({
            title: translate(title),
            text: translate(description),
            showCancelButton: true,
            focusCancel: true,
            confirmButtonText: translate('ra.action.confirm'),
            cancelButtonText: translate('ra.action.cancel'),
            denyButtonColor: '#0b872c',
            showLoaderOnConfirm: true,
            icon,
            preConfirm: async () => {
                await onConfirm()
            },
            allowOutsideClick: () => !Swal.isLoading()
        })

        if (result.isDismissed) {
            return
        }

        if(!result.isConfirmed) {
            return
        }

    };

    return (
        <div onClick={handleClick} style={{margin: "0 4px"}}>
            {children}
        </div>
    )
})

export default Popconfirm;
